<template>
  <AddEditBusinessCardDialog />
</template>

<script>
import AddEditBusinessCardDialog from "@/components/AddEditBusinessCardDialog";
export default {
  components: {
    AddEditBusinessCardDialog,
  },
};
</script>

<style>
</style>